import cart from '../../components/cart/Cart';
import quantitySelect from '../../components/layout/quantitySelect';

export default class CartPage {
  constructor() {
    this.cart = cart.getInstance();
    this.cartForm = document.querySelector('.js-cart-form');
    this.cartPageWrapper = document.querySelector('.js-cart-container');
    this.cartTableWrapper = document.querySelector('.js-cart-table-wrap');
    this.cartTotalSummaryWrapper = document.querySelector('.js-cart-total-summary-wrap');

    if (this.cartForm) {
      this.setupQuantityCallbacks(this.cartForm);
    }

    this.cart.on('updated', (state, cartTable, cartTotalSummary) => {
      this.buildCartTable(cartTable);
      this.buildCartTotalSummary(cartTotalSummary);
      const cartTableInUpdatedCart = document.querySelector('.js-cart-table-wrap');
      if (cartTableInUpdatedCart) {
        this.setupQuantityCallbacks(cartTableInUpdatedCart);
      }
    });
  }

  buildCartTable(cartTable) {
    this.cartTableWrapper.innerHTML = cartTable;
  }

  buildCartTotalSummary(cartSummary) {
    this.cartTotalSummaryWrapper.innerHTML = cartSummary;
  }

  setupQuantityCallbacks(cartForm) {
    const qtySelects = [...cartForm.querySelectorAll('.js-quantity-select')];
    quantitySelect(qtySelects, this.qtySelectCallback.bind(this));
  }

  qtySelectCallback(qtySelect, newValue) {
    const { key } = qtySelect.dataset;
    const cartForm = document.querySelector('.js-cart-form');
    const itemEl = cartForm.querySelector(`.js-cart-item[data-key="${key}"]`);
    const quantityValue = qtySelect.value;
    // const qtySelectWrap = qtySelect.parentNode.closest('.js-quantity-select');
    // const qtySelectIncrementButton = qtySelectWrap.querySelector('[data-increment="1"]');

    const qtyWrapper = qtySelect.parentNode.closest('.js-quantity-select-wrap');
    qtyWrapper.classList.add('quantity-select-wrap--loading');
    // eslint-disable-next-line radix
    const quantity = parseInt(quantityValue, 10);
    if (newValue === 0) {
      itemEl.classList.add('is-removing');
      this.cart
        .removeItem(key)
        .then(() => {
          itemEl.parentNode.removeChild(itemEl);
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    }

    itemEl.classList.add('is-updating');
    this.cart
      .updateItem(key, { quantity }, true)
      .then(() => {
        itemEl.classList.remove('is-updating');
        setTimeout(() => {
          qtyWrapper.classList.remove('quantity-select-wrap--loading');
        }, 500);
      })
      .catch(() => {
        itemEl.classList.remove('is-updating');
      });
  }

  recalculateItemCount(cartForm) {
    let totalCount = 0;
    const itemEls = cartForm.querySelectorAll(`.js-cart-item`);

    [...itemEls].forEach((item) => {
      const itemCount = item.querySelector('.js-quantity-select input').value;
      // eslint-disable-next-line radix
      totalCount += parseInt(itemCount);
    });

    [...document.querySelectorAll('.js-cart-count')].forEach((cartCountEl) => {
      cartCountEl.innerHTML = totalCount;
    });
  }
}

new CartPage();
